import styled from "styled-components";

export const PageContent = styled.div`
  display: flex;
  flex: 1;
`;
